import React from 'react';
import LiceList from "../../../../components/Operation/LiceList";
import AttachFile from "../../../../components/Popup/PopupOpInfo/_component/AttachFile";
import ServiceInfo from "../../../../components/Popup/PopupOpInfo/Info/Service/ServiceInfo";
import { IActivityLogByUnit } from "../../../../components/TrackingOp/ActivitiesLog/ActivityLogs2";
import { convertStepName, durationTxtByStartAndFinish } from "../../../../util/varibles/global";
import { IOperation2, IService2 } from "../../../../util/varibles/interface";
import Checklists from "../../_components/Checklists";
import FishDisease from "../../_components/FishDisease";
import Operation from "../../_components/Operation";
import stylesOp from "../../_components/Operation/style.module.scss";
import OperationTime from "../../_components/OperationTime";
import Route from "../../_components/Route";
import Vessel from "../../_components/Vessel";
import ViewNote from '../../_components/ViewNote';
import WrapperActivityLog from "../../_components/WrapperActivityLog";

interface IProps {
    data: IOperation2<IService2>
    isOwn: boolean
}

const Service: React.FC<IProps> = ({ data, isOwn }) => {
    const { note = '', files = [], sub_operations, request_tab_id } = data.operation;
    const isNote = note.length === 0;

    const { activity_log } = data;
    const est_start_time = activity_log[0].est_start_time;
    const est_finish_time = activity_log[activity_log.length - 1].est_start_time;

    const activityLog: IActivityLogByUnit[] = activity_log.reduce((list: any, item: any, index: number) => {
        const { key, unit_id } = item;
        const steps = [{ id: key, name: convertStepName([key])[0] || "" }];
        const isExist = list.findIndex((sub: any) => sub.id === unit_id);
        const value = { ...item, steps, index };
        if (isExist === -1) {
            return [...list, { id: unit_id, name: unit_id, list: [value] }];
        }
        list[isExist].list.push(value);
        return list
    }, []);

    return <div className='col-span-2 pb-3'>
            <div className='grid grid-cols-1 items-stretch gap-[15px] min-[901px]:grid-cols-[minmax(0,2fr)_minmax(290px,1fr)] mb-[15px]'>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <Operation {...{ isNote }}>
                <OperationTime activity_log={activity_log} />
                <div className={stylesOp['info-line']}>
                    <span>Planned duration: </span>
                    <span>{durationTxtByStartAndFinish(est_start_time, est_finish_time)}</span>
                </div>
                {request_tab_id && <div className={stylesOp['info-line']}>
                    <span>Request ID: </span>
                    <span>{request_tab_id}</span>
                </div>}
                <div className={stylesOp['info-line']}>
                    <AttachFile files={files} />
                </div>
                <FishDisease diseases={data.operation.diseases || []} units={sub_operations} wrapperClass='mb-[5px]' />
                <LiceList diseases={data.operation.diseases || []} />
                <div className="mt-2">
                    <ServiceInfo operation={data.operation as IService2} />
                </div>
                <ViewNote data={data} isOwn={isOwn} note={note} />
                    </Operation>
                </div>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <Checklists />
                </div>
            </div>
            <div className='grid grid-cols-1 items-stretch gap-[15px] min-[901px]:grid-cols-[minmax(0,2fr)_minmax(290px,1fr)] mb-[15px]'>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <Vessel />
                </div>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <WrapperActivityLog
                        isOwn={isOwn}
                        data={data}
                        activity_log={activityLog}
                        activity_log_root={activity_log}
                    />
                </div>
            </div>
            <Route />
    </div>;
};

export default Service;
